import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { logbaseService } from '../../services/logbase.service';

@Component({
  selector: "app-add-config",
  templateUrl: "./add-config.component.html",
  styleUrls: ["./add-config.component.scss"],
})
export class AddConfigComponent implements OnInit {
  configForm: FormGroup;

  nobuaListDropDownSettings = {}; //Settings for Multi Selection Dropdown
  nobuaList = [];
  nobuaFilteredList = [];

  configurationType = "MULTIPLE";
  isNoubaHasRightPattern = false;

  initialItem: any;
  initialNoubaCodeArray: any;
  isDataSubmitLoading = false;
  isErrorFound = false;
  customValue = "";
  selectedItems = [];

  constructor(
    public dialogRef: MatDialogRef<AddConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private logbaseService: logbaseService,
    public snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.initialNoubaCodeArray = this.data.payload.noubCodePattern.split(",");
    this.setConfigForm();
    this.setNoubaListDropdownSettings();
    this.setNoubaListDropdown();
  }

 
  setConfigForm() {
    this.setValueNoubaPattern(this.data.payload.noubCodePattern);
  }

  setValueNoubaPattern(pattern: string) {
    this.customValue = pattern;
    this.searchFilteredNoubaList(pattern);
  }

  setNoubaListDropdownSettings() {
    this.nobuaListDropDownSettings = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: "Select",
      enableCheckAll: true,
      allowSearchFilter: true,
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 3,
      enableSearchFilter: true,
      limitSelection: 60,
  };
  }

  setNoubaListDropdown() {
    this.logbaseService.getDeliveryPoints().subscribe((result) => {
      let deliveryPointsResult = result.response;
      let deliveryPointArr = [];
      deliveryPointsResult.forEach(function (value, key) {
        deliveryPointArr.push({ id: key + 1, itemName: value.deliveryPoint });
      });
      console.log(deliveryPointArr)
      this.setNoubaList(deliveryPointArr);
      this.setInitialData();
    });
  }

  setNoubaList(listItems) {
    this.nobuaList = listItems;
    this.nobuaFilteredList = listItems;
  }

  setInitialData() {
    let noubaInitialArray = this.initialNoubaCodeArray;
    let noubaInitialArrLength = noubaInitialArray.length;
    let isNoubaPresent = this.isContainText(noubaInitialArray[0]);

    if (noubaInitialArrLength == 1 && !isNoubaPresent) {
      this.setConfigurationType("SINGLE");
      this.onNoubaCodeValidation(this.data.payload.noubCodePattern);
      this.selectedItems = [];
    } else {
      this.selectedItems = this.getNoubaSelectedArray();
    }
  }

  isContainText(noubaPatternTxt: string) {
    return this.nobuaList.some((item) => {
      return item.itemName == noubaPatternTxt;
    });
  }

  setConfigurationType(type: string) {
    this.configurationType = type;
  }

  getNoubaSelectedArray() {
    let noubaSelectedArray = [];
    let noubaInitialArray = this.initialNoubaCodeArray;

    noubaInitialArray.forEach((name) => {
      let compareData = name;
      let filterNoubaArr = this.nobuaList.filter(
        (item) => item.itemName == compareData
      );
      noubaSelectedArray.push(filterNoubaArr[0]);
    });
    
    return noubaSelectedArray;
  }

  radioChange(event) {
    let selectedValue = event.value;
    if (selectedValue == "MULTIPLE") {
      let noubaSelectedItemArray = this.initialNoubaCodeArray;

      var isPresent = this.nobuaList.some(function (item) {
        return item.itemName == noubaSelectedItemArray[0];
      });

      if (isPresent) {
        this.selectedItems = this.getNoubaSelectedArray();
      }
    } else {
      this.setValueNoubaPattern(this.data.payload.noubCodePattern);
    }
  }

  onPatternSelect(selectedItem) {
    this.setValueNoubaPattern(selectedItem);
    }

  onNoubaCodeValidation(searchText: string) {
    this.isNoubaHasRightPattern = this.validateNoubaPattern(searchText);
    if (!this.isNoubaHasRightPattern) {
      this.isErrorFound = true;
    } else {
      this.customValue = searchText;
      this.isErrorFound = false;
  }
    this.searchFilteredNoubaList(searchText);
  }

  validateNoubaPattern(noubaPattern: string) {
    let splitArray = noubaPattern.split("-");
    let patternInvalid = false;

    if (this.isRangeAvailable(noubaPattern)) {
      let firstNoubaRangeTxt = splitArray[0].substring(1, 2);
      let secondNoubaRangeTxt = splitArray[1].substring(1, 2);
      let thirdNoubaRangeTxt = splitArray[1].substring(2, 3);

      if (firstNoubaRangeTxt == secondNoubaRangeTxt) {
        splitArray.forEach((val, key) => {
          if (!this.isPatternValid(val)) {
            patternInvalid = true;
          }
        });
      } else {
        patternInvalid = true;
      }
    } else {
      if (!this.isPatternValid(noubaPattern)) {
        patternInvalid = true;
      }
    }

    if (patternInvalid) {
      return false;
    } else {
      return true;
    }
  }

  isPatternValid(value: string) {
    if (this.isMinMaxValid(value, 1, 4)) {
      if (this.isAlaphabet(value)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isMinMaxValid(value: string, min: number, max: number) {
    return value.length > min && value.length < max ? true : false;
  }

  isAlaphabet(value: string) {
    let pattern = /^[a-zA-Z]+$/;
    return pattern.test(value.charAt(0));
  }

  isRangeAvailable(value: string) {
    let validateString = "-";
    return value.includes(validateString)
      ? this.isMinMaxValid(value, 1, 8)
      : false;
  }

  onItemSelect(item) {
    console.log(this.selectedItems);
  }

  OnItemDeSelect(item) {
    console.log(this.selectedItems);
  }

  onSelectAll(items: any) {
    console.log(items);
  }
  onDeSelectAll(items: any) {
    console.log(items);
  }

  onFilterSelectAll(item) {}

  getSelectedItemsString() {
    let selectedItemArrString = [];
    this.selectedItems.forEach((item) => {
      selectedItemArrString.push(item.itemName);
    });
    return selectedItemArrString.join();
  }

  onSubmit() {
    this.isDataSubmitLoading = true;

    let noubaPatternItems =
      this.configurationType != "MULTIPLE"
        ? this.customValue
        : this.getSelectedItemsString();

    if (this.data.type == "editNoubaPattern") {
      this.logbaseService
        .editNoubaPattern({
          id: this.data.payload.id,
          noubCodePattern: noubaPatternItems,
          user: JSON.parse(localStorage.getItem("currentUser")),
        })
        .subscribe(
          (result) => {
            this.isDataSubmitLoading = false;
            let responseMessage = "";

          if (result.status.statusMessage == "SUCCESS") {
            this.dialogRef.close("Updated");
              responseMessage = "Nouba pattern Updated";
          }
            if (result.status.statusMessage == "FAILURE") {
              responseMessage =
                "Failed to update : " + result.status.displayMessage;
            }

            this.snackBar.open(responseMessage, "Ok", {
              duration: 2000,
        });
          },
          (error) => {
            this.isDataSubmitLoading = false;
            console.log("error in update" + JSON.stringify(error));
    }
        );
  }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  searchFilteredNoubaList(val: string) {
    this.nobuaFilteredList = this.filterNoubaList(val);
  }

  filterNoubaList(val: string): string[] {
    return this.nobuaList.filter(
      (option) => option.itemName.toLowerCase().indexOf(val.toLowerCase()) === 0
    );
  }
}
